// Musi być pierwszym importem — patrz komentarz w `instrument.ts`.
import './instrument.js';

import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@sea-wars/ui/tokens.css';
import './app.css';
import { App } from './App.js';
import { SessionProvider } from './api/session.js';
import { registerServiceWorker } from './registerServiceWorker.js';

registerServiceWorker();

const container = document.getElementById('root');
if (!container) throw new Error('Brak elementu #root');

createRoot(container).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<CrashScreen />}>
      <BrowserRouter>
        <SessionProvider>
          <App />
        </SessionProvider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);

/** Awaryjny ekran zamiast białej strony — patrz `docs/05` §5.6 ("offline shell"), ten sam duch. */
function CrashScreen() {
  return (
    <div className="sw-paper app">
      <div className="card card--narrow crash-screen">
        <h2 className="hand">Coś poszło nie tak</h2>
        <p>Ekran się wykrzaczył. Odświeżenie strony zwykle pomaga.</p>
        <button type="button" className="btn btn--primary" onClick={() => location.reload()}>
          Odśwież
        </button>
      </div>
    </div>
  );
}
